import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import { loadFactSheet, downloadReport } from '../../../actions/FactSheetActions';
import { addTriggeredEvent } from '.././../../actions/UserActions';
import { ApplicationState } from '../../../reducers/Index';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FactSheetState } from '../../../interface/FactSheetInterface';
import { UserState } from '../../../interface/MyInterfaces'

import { downloadFactSheetPDF } from './FactSheetButtonHelpers'

import GovtReportHeader from "../GovtReportHeader";
import GovtReportFooter from "../GovtReportFooter";
import EmployeeBullets from './EmployeeBullets';
import UniversityList from './UniversityList';
import AgencyChart from './AgencyChart';
import DoctorBullets from './DoctorBullets';
import StateLegislativeTable from './StateLegislativeTable';
import StateLegislativeMaps from './StateLegislativeMaps';
import CongressionalDistrictTable from './CongressionalDistrictTable';
import CongressionalDistrictMaps from './CongressionalDistrictMaps';
import DashboardReportActionsBar from '../../../layouts/DashboardReportActionsBar';

interface FactSheetProps {
    FactSheetState?: FactSheetState
    UserState?: UserState
    loadFactSheet?: any;
    loadFactSheetHomeStateInfo: Function;
    addTriggeredEvent?: any;
    downloadReport?: any;
}

interface FactSheetRealState {
    downloadWasCalled?: boolean;
    currentDateTime?: any;
    isStateLegislative: boolean;
}

class FactSheet extends React.Component<FactSheetProps & RouteComponentProps<{}>, FactSheetRealState> {
    constructor(props) {
        super(props);
        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();

        
        this.state = {
            currentDateTime: currentDate,
            downloadWasCalled: false,
            isStateLegislative: false
        };
        this.pdf = this.pdf.bind(this);
        this.handleDownloadFiles = this.handleDownloadFiles.bind(this);
    }

    handleDownloadFiles() {
        this.props.downloadReport(this.props.FactSheetState, this.props.match.params["factSheetType"]);
    }

    pdf() {
        downloadFactSheetPDF(this.state, this.props);
        this.setState({ downloadWasCalled: false });
    }

    componentDidMount() {
        if (this.props.match.params !== undefined &&
            this.props.match.params["link_id"] !== undefined &&
            this.props.match.params["p1"] !== undefined &&
            this.props.match.params["p2"] !== undefined) {

        }
        else {
            const isStateLegislative = this.props.match.params["factSheetType"] == "stateLegislative";

            const reportVintage = isStateLegislative
                ? this.props.UserState.report_vintage_state
                : this.props.UserState.report_vintage_congress;

            const sbEmployeeVintageForFactSheet = isStateLegislative
                ? this.props.UserState.report_vintage_state_SB
                : this.props.UserState.report_vintage_congress_SB;

            this.props.loadFactSheet(this.props.UserState.report_display_id, reportVintage, sbEmployeeVintageForFactSheet, isStateLegislative);
            //this.props.loadFactSheetHomeStateInfo(this.props.UserState.report_display_id, sbEmployeeVintageForFactSheet);
            
        }

        this.props.addTriggeredEvent(`${this.props.match.params["factSheetType"] == 'stateLegislative' ? "State Legislative" : "Congressional District"} Fact Sheet`, this.props.UserState.username, this.props.UserState.display_id, "landing page")
    }

    public render() {
        console.log(this.props.FactSheetState)
        const { match } = this.props;
        const isStateLegislative = this.props.match.params["factSheetType"] == 'stateLegislative';
        const isCongressionalDistrict = this.props.match.params["factSheetType"] != 'stateLegislative';
        const ifState_HasItLoaded = this.props.FactSheetState &&
            this.props.FactSheetState.legislativeUpperTable && this.props.FactSheetState.legislativeUpperTable.length > 0 &&
            this.props.FactSheetState.employment_bullets != "";
        const releaseDate = new Date(this.props.FactSheetState.homestate_info.release_date).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        this.props.FactSheetState.release_date = releaseDate

        return <div className='govtreport container-fluid factsheet boxshadow-div'>
            <DashboardReportActionsBar currentUrl={match.url} />
            <div className="row">
                <GovtReportHeader report_university_name={this.props.UserState.report_university_name && this.props.UserState.report_university_name.replace('Texas CPUPC IRIS members','Five Texas Public Universities')}
                    heading_text={isStateLegislative ? "State Legislative Fact Sheet" : "Congressional Fact Sheet"} />
            </div>
            {(isStateLegislative && !ifState_HasItLoaded) && <i className="fa fa-spinner">Loading..</i>}
            {(isStateLegislative && ifState_HasItLoaded && this.props.UserState.report_display_id == "999040")
                &&
                <div className="row">
                    <div className="col-md-9" style={{ paddingTop: "20px" }}>
                    <span>
                        This report aggregates data from five public universities in Texas that are members of IRIS and the Council of Public University Presidents and Chancellors (CPUPC): Texas A&M University, Texas Tech University, The University of Texas at Dallas, The University of Texas at San Antonio, and Tarleton State University.
                    </span>
                </div>
                <div className="col-md-3">
                    <a className="button pdfdownload" onClick={this.pdf}>Download PDF Report</a><br />
                    <a style={{ marginBottom: "4px", marginTop: "10px" }} className="button exceldownload" onClick={this.handleDownloadFiles}>Download Data Files</a>
                </div>

                </div>
            }
            {((isStateLegislative && ifState_HasItLoaded) || (isCongressionalDistrict && (this.props.FactSheetState.employment_bullets != "")))
                &&
                <div className="row">
                    <EmployeeBullets total_employees={this.props.FactSheetState.total_employees}
                        employment_text={this.props.FactSheetState.employment_text}
                        employment_bullets={this.props.FactSheetState.employment_bullets}
                    />
                {this.props.UserState.report_display_id != "999040" &&
                    <div className="col-md-3">
                        <a className="button pdfdownload" onClick={this.pdf}>Download PDF Report</a><br />
                        <a style={{ marginBottom: "4px", marginTop: "10px" }} className="button exceldownload" onClick={this.handleDownloadFiles}>Download Data Files</a>
                    </div>
                }
                </div>
            }

        {((isStateLegislative && ifState_HasItLoaded) || (isCongressionalDistrict && (this.props.FactSheetState.employment_bullets != "")))
            &&
                <AgencyChart
                    report_display_id={this.props.UserState.report_display_id}
                    top_heading={this.props.FactSheetState.top_heading}
                    list_agencies={this.props.FactSheetState.list_agencies} />
        }
        {((isStateLegislative && ifState_HasItLoaded) || (isCongressionalDistrict && (this.props.FactSheetState.employment_bullets != "")))
            &&
            <DoctorBullets
                stayed_bullet={this.props.FactSheetState.stayed_bullet}
            />
        }

            {((isStateLegislative && ifState_HasItLoaded) || (isCongressionalDistrict && (this.props.FactSheetState.employment_bullets != "")))
                &&
                <div className="row">
                    <UniversityList
                        university={this.props.FactSheetState.university}
                        description={this.props.FactSheetState.description}
                    />
                </div>
            }
            
            {((isStateLegislative && ifState_HasItLoaded) || (isCongressionalDistrict && (this.props.FactSheetState.employment_bullets != ""))) &&
                this.renderFactSheetTableAndMaps(isStateLegislative)
            }
            <div className="row" style={{ paddingBottom: 40 }}>
                <div className="col-md-3"></div>
                <div className="col-md-3">
                    <a className="button pdfdownload" onClick={this.pdf}>Download PDF Report</a>
                </div>
                <div className="col-md-3">
                    <a className="button exceldownload" onClick={this.handleDownloadFiles}>Download Data Files</a>
                </div>
                <div className="col-md-3"></div>
            </div>

        </div>
    }

    renderFactSheetTableAndMaps(isStateLegislative) {
        if (isStateLegislative) {
            return <div className="factSheet">

                <StateLegislativeTable
                    statelegislative_heading={this.props.FactSheetState.statelegislative_heading1}
                    current_year={this.props.FactSheetState.current_year}
                    start_year={this.props.FactSheetState.start_year}
                    tableData={this.props.FactSheetState.legislativeUpperTable}
                    repString="Sen. "
                />
                <StateLegislativeMaps
                    university={this.props.FactSheetState.university}
                    current_year={this.props.FactSheetState.current_year}
                    start_year={this.props.FactSheetState.start_year}
                    latest_map={this.props.FactSheetState.upperMapLatest}
                    range_map={this.props.FactSheetState.upperMap}
                    title_text="State Senate District"
                    state={this.props.FactSheetState.statename}
                />
                
                <StateLegislativeTable
                    statelegislative_heading={this.props.FactSheetState.statelegislative_heading2}
                    current_year={this.props.FactSheetState.current_year}
                    start_year={this.props.FactSheetState.start_year}
                    tableData={this.props.FactSheetState.legislativeLowerTable}
                    repString="Rep. "
                />

                <StateLegislativeMaps
                    university={this.props.FactSheetState.university}
                    current_year={this.props.FactSheetState.current_year}
                    start_year={this.props.FactSheetState.start_year}
                    latest_map={this.props.FactSheetState.lowerMapLatest}
                    range_map={this.props.FactSheetState.lowerMap}
                    title_text="State House/Assembly District"
                    state={this.props.FactSheetState.statename}
                />

            </div>
        } else {
            return <div className="factSheet">
                <CongressionalDistrictTable
                    spending_heading={this.props.FactSheetState.spending_heading}
                    spending_congress={this.props.FactSheetState.spending_congress}
                    current_year={this.props.FactSheetState.current_year}
                    start_year={this.props.FactSheetState.start_year}
                    spending_congress_total={this.props.FactSheetState.spending_congress_total}
                    spending_congress_total_range={this.props.FactSheetState.spending_congress_total_range}
                />

                <CongressionalDistrictMaps
                    university={this.props.FactSheetState.university}
                    current_year={this.props.FactSheetState.current_year}
                    start_year={this.props.FactSheetState.start_year}
                    congress_map={this.props.FactSheetState.congress_map}
                    congress_map_range={this.props.FactSheetState.congress_map_range}
                    usStateList={this.props.FactSheetState.usStateList}
                    state_fips={this.props.FactSheetState.state_fips}
                />

            </div>
        }
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            downloadReport: downloadReport,        
            loadFactSheet: loadFactSheet,
            addTriggeredEvent: addTriggeredEvent
        }, dispatch
    )
}

const mapStateToProps = (state: ApplicationState) => ({
    UserState: state.userProperties,
    FactSheetState: state.factSheetProperties
});


export default connect(
    mapStateToProps, // Selects which state properties are merged into the component's props
    matchDispatchToProps
)(FactSheet);
